import React from 'react'
import { getEnv } from '../../../config'

function Info() {
  return (
    
<div className="panel-horizontal-content" style={{ backgroundColor: '#F3F6F9' }}>
  <div className="panel-horizontal mb-5">
  <p className="headline-lg">El visor de mapa permite ver la información integrada con la posibilidad de prender y apagar las
distintas capas. Posibilita hacer búsquedas, agregar servicios y generar información mediante
herramientas de digitalización.</p>
  </div>
  <div className="d-flex justify-content-center align-items-center w-100 panel-horizontal">
  <a className="btn btn-outline-primary" href={getEnv("REACT_APP_PORTAL_URL") ? getEnv("REACT_APP_PORTAL_URL") : 'https://visualizador-front-dev.gcba.gob.ar/' } target="_blank" rel="noopener noreferrer">
  Visor de Mapas
</a>
  </div>
</div>

  )
}

export default Info